import * as React from "react";
import { useMutation } from "@grandvisionhq/graphql";
import { useIntl } from "@grandvisionhq/state";
import { CANCEL_APPOINTMENT_BY_ID } from "../../../../../../../queries/v3/pages/CancelAppointment/queries/cancel-appointment-by-id.js";
import { fromCancelAppointmentQueryToAppointment } from "../../../../../adapters/v3/pages/CancelAppointment/hooks/api/adapters/fromCancelAppointmentQueryToAppointment.js";
function isAppointment(result) {
  return result.__typename === "Appointment";
}
const useCancelAppointmentById = (token = "") => {
  const { locale } = useIntl();
  const [query, queryState] = useMutation(
    CANCEL_APPOINTMENT_BY_ID,
    {
      context: {
        forwardHeaders: {
          "Accept-Language": locale,
          Authorization: `Bearer ${token}`
        },
        timeout: 3e4
      },
      onError: (error) => {
        console.error(`Error occurred while executing CANCEL_APPOINTMENT_BY_ID mutation: `, error);
      }
    }
  );
  const data = React.useMemo(() => {
    return queryState.data?.cancelAppointment && isAppointment(queryState.data?.cancelAppointment) ? fromCancelAppointmentQueryToAppointment(
      queryState.data.cancelAppointment
    ) : null;
  }, [queryState]);
  return React.useMemo(() => [query, { ...queryState, data }], [data, queryState, query]);
};
export {
  useCancelAppointmentById as default,
  isAppointment
};
//# sourceMappingURL=use-cancel-appointment-by-id.js.map
